export default "__VITE_ASSET__a29de783__"